<mat-icon class="itmbIcon">{{ video.icon }}</mat-icon>

@if (cachedUrl) {
    <img class="itmbImg" [src]="cachedUrl" [alt]="video.label" draggable="false" />
}
